var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
        {active: _vm.config.value === _vm.sortBy},
        {'is-reverse': _vm.isReverse},
        ("control-" + (_vm.config.value)) ],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.emitValue(_vm.config.value, _vm.config.iteratees)}}},[_vm._v("\n    "+_vm._s(_vm.config.listLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }